export const INITIALIZE = 'INITIALIZE';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_UP = 'SIGN_UP';

export const initialState = {
  authenticated: false,
  initialised: false,
  accessToken: '',
};

type State = typeof initialState;

type InitialiseAction = {
  type: 'INITIALIZE';
  payload: { authenticated: boolean };
};

type SignInSuccess = {
  type: 'SIGN_IN_SUCCESS';
  payload: { accessToken: string };
};

type SignOut = {
  type: 'SIGN_OUT';
  payload?: null;
};

type Action = InitialiseAction | SignInSuccess | SignOut;

export const JWTReducer = (state: State, { type, payload }: Action) => {
  switch (type) {
    case 'INITIALIZE':
      return {
        ...state,
        initialised: true,
        accessToken: '',
        authenticated: payload.authenticated,
      };

    case 'SIGN_IN_SUCCESS':
      return {
        ...state,
        initialised: true,
        authenticated: true,
        accessToken: payload.accessToken,
      };

    case 'SIGN_OUT':
      return {
        ...state,
        authenticated: false,
        accessToken: '',
      };
    default:
      return state;
  }
};
